import React from 'react';
import PropTypes from 'prop-types';
import VehicleForm from '../components/VehicleForm';
import { PRODUCT_CATEGORY_TYPES } from '../ProductConstants';
import CarInsuranceForm from '../components/CarInsuranceForm';
import LoanForm from '../components/LoanForm';

function ProductMetaFactory({
    category,
    values,
}) {
    if (category === PRODUCT_CATEGORY_TYPES.VEHICLE) {
        return <VehicleForm values={values}/>;
    }
    if (category === PRODUCT_CATEGORY_TYPES.VEHICLE_INSURANCE || category === PRODUCT_CATEGORY_TYPES.PERSONAL_INSURANCE) {
        return <CarInsuranceForm values={values} />;
    }
    if (category === PRODUCT_CATEGORY_TYPES.LOAN) {
        return <LoanForm values={values} />;
    }

    return null;
}

ProductMetaFactory.propTypes = {
    category: PropTypes.string,
    // eslint-disable-next-line react/forbid-prop-types, react/require-default-props
    values: PropTypes.object,
};

ProductMetaFactory.defaultProps = {
    category: '',
    values: { },
};

export default ProductMetaFactory;
